<template>
    <v-app>
      <div class="row">
        <div class="col-12">
          <div class="card ">
            <div class="card-header">
              <div class="card-title pt-3 px-3 d-flex justify-content-between">
                <div class="breadcrumb-left">
                  <h4>  My courses</h4>
                  <div class="breadcrumb-sub-header">
                    <router-link to="/dashboard">Dashboard</router-link>
                    \   My courses
                  </div>
                </div>


              </div>
            </div>
            <div class="card-body ">
              <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
                <div class="row">
                  <div class="col-md-3">

                    <v-select
                        class="form-control"
                        outlined
                        v-model="search.academic_year"
                        dense  v-on:keyup.enter="__get()"
                        :items="academicYears"
                        item-text="title"
                        item-value="id"
                        label="Batch"
                    >
                    </v-select>
                  </div>
                  <div class="col-md-2">

                    <v-select
                        class="form-control"
                        outlined v-on:keyup.enter="__get()"
                        :items="programs"
                        v-model="search.program_id"
                        @change="getGrades"
                        dense
                        item-text="title"
                        item-value="id"
                        label="Program"
                    >
                    </v-select>

                  </div>
                  <div class="col-md-2" v-show="search.program_id">

                    <v-select
                        class="form-control"
                        outlined v-on:keyup.enter="__get()"
                        :items="gradesLevels"
                        v-model="search.grade_id"
                        dense
                        item-text="title"
                        item-value="id"
                        label="Semester/Year"
                    >
                    </v-select>
                  </div>
                  <v-col cols="12" md="12" class="text-right">
                    <v-btn
                        @click="__get()"
                        class="btn btn-primary btn-search "
                        :loading="loading"
                    >
                      <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                      Search
                    </v-btn>
                  </v-col>

                </div>
              </div>
              <div class="table-responsive">
                <v-skeleton-loader
                    type="table-thead"
                    v-if="loading"
                >
                </v-skeleton-loader>

                <v-skeleton-loader
                    v-if="loading"
                    type="table-row-divider@25"
                >
                </v-skeleton-loader>
                <table class="table"   v-if="!loading">
                  <thead>
                    <tr class="px-3">
                      <th class="px-3">Image</th>
                      <th class="px-3">Title</th>
                      <th class="px-3">Subject code</th>
                      <th class="px-3">Duration</th>
                      <th class="px-3">Program</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-show="assignedTeacherCourseList.length > 0" v-for="(course, index) of assignedTeacherCourseList" :key="index">
                      <td class="px-3">
                        <v-img
                           max-width="140"
                            :src="course.cover_image_path&& course.cover_image_path['real'] ? course.cover_image_path['real'] :  'https://images.unsplash.com/photo-1515125520141-3e3b67bc0a88?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2251&q=80image=180'"
                        ></v-img>
                      </td>
                      <td class="px-3">
                          <a  @click="showCourseDetail(course)" class="font-weight-medium">{{course.title}}</a>
                        </td>
                      <td class="px-3">
                          <span class="font-weight-medium">{{course.subject_code}}</span>
                        </td>
                      <td class="px-3">
                          <span class="font-weight-medium">{{` ${ course.duration } ${ course.duration_unit }` }}</span>
                        </td>
                      <td class="px-3">
                        <div class="text-secondary">
                          <span class="font-weight-black">Grade:</span> {{ course.grade_title }}
                        </div>
                        <div class="text-secondary">
                          <span class="font-weight-black">Program:</span> {{ course.program_title }}
                        </div>
                      </td>
                    </tr>
                    <tr v-if="assignedTeacherCourseList.length==0">
                      <td colspan="5" class="text-center">
                        <strong>No items found.</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </div>
        </div>
      </div>
      <v-dialog v-model="courseDetailDialog" max-width="800">
            <v-card
                    class="mx-auto"
            >
                <v-img
                        height="150"
                        :src="course.cover_image_path&& course.cover_image_path['real'] ? course.cover_image_path['real'] :  'https://picsum.photos/400/200/?image=180'"
                ></v-img>
                <v-card-title> {{course.title}}

                </v-card-title>

                <v-card-text>
                    <div class=" text-subtitle-1">

                        <b>Subject code:</b> {{ course.subject_code }}<br>
                        <v-row>
                            <v-col cols="6">
                                <b>Grade:</b> {{ course.grade_title }} <br>
                                <span v-if="course.duration "><b>Duration:</b> {{` ${ course.duration } ${ course.duration_unit }` }}<br></span>
                            </v-col>
                            <v-col cols="6">
                                <b>Program:</b> {{ course.program_title }} <br>
                                <span v-if="course.mark_type "><b>Mark type:</b> {{` ${ course.mark_type } ` }}<br></span>
                            </v-col>

                        </v-row>




                        <v-divider class="mx-4"></v-divider>
                        <div class="d-flex flex justify-content-around">
                            <div>
                                <strong>Theory</strong>
                                <div>Theory marks :  {{course.theory_mark || 0 }} </div>
                                <div>Theory pass marks :  {{course.theory_pass_mark || 0 }} </div>
                                <div>Theory credit hours :  {{course.theory_credit_hours || "N/A" }} </div>
                                <div>Theory grade points :  {{course.theory_grade_points || "N/A" }} </div>
                            </div>
                            <div v-if="course.has_practical">
                                <strong>Practical</strong>
                                <div>Practical marks :  {{course.practical_mark || 0 }} </div>
                                <div>Practical pass marks :  {{course.practical_pass_mark || 0 }} </div>
                                <div>Practical credit hours :  {{course.practical_credit_hours || "N/A" }} </div>
                                <div>Practical grade points :  {{course.practical_grade_points || "N/A" }} </div>

                            </div>
                        </div>
                        <v-divider class="mx-4"></v-divider>
                        <p v-if="course.content" v-html="course.content"></p>
                        <!--begin::Navigation-->
                        <!--                    <div class="navi navi-hover"  v-if="course.lesson_plan.length">-->


                        <!--                      <b-dropdown-text tag="div" class="navi-item" v-for="(plan,i) in course.lesson_plan" :key="plan.id">-->
                        <!--                        <router-link-->
                        <!--                                :to="{ name:'courses-summary',params:{-->
                        <!--                                                                                  lesson_planner_id:plan.id-->
                        <!--                                                                                }}"-->
                        <!--                                class="navi-link">-->
                        <!--                                                                    <span class="navi-icon">-->
                        <!--                                                                      <i class="flaticon2-copy"></i>-->
                        <!--                                                                    </span>-->
                        <!--                          <span class="navi-text">{{plan.title}}</span>-->
                        <!--                        </router-link>-->
                        <!--                      </b-dropdown-text>-->

                        <!--                    </div>-->
                        <!--end::Navigation-->

                    </div>
                </v-card-text>

            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import UserService from "@/core/services/user/UserService";
    import AcademiClassService from "@/core/services/academic-class/AcademicClassService";
    import AcademicClassTeacherService from "@/core/services/academic-class/class-teacher/AcademicClassTeacherService";
    const academicClassTeacherService = new AcademicClassTeacherService();
    import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";
    const userService = new UserService();
    const academiClassService = new AcademiClassService();
    import GeneralMixin from "@/mixins/GeneralMixin";

    export default {
        name: "teacher-courses",
        mixins: [GeneralMixin,SiteSettingMixin],

        data() {
            return {
                search: {
                    academic_year: null,
                    program_id: null,
                    grade_id: null,
                    type: null,
                },
                assignedTeacherCourseList: [],
                loading: false,
                course: {},
                courseDetailDialog: false,
            }
        },
        mounted() {
          if(this.checkTeacherMenuAccess('courses')==false ){
            this.$router.push({name: '404'})
          }
            this.__get();
            this.getAcademicYears();
            this.getPrograms();
        },
        computed: {
            currentUser() {
                return this.$store.getters.currentUser;
            },
        },
        methods: {
            __get(){
                this.getAssignedTeacherCoursesList(this.search);

            },
            getAssignedTeacherCoursesList(search) {
                this.loading = true;
                academicClassTeacherService.getCourseByTeacherId(search).then(response => {
                    this.assignedTeacherCourseList = response.data.courses;
                }).catch((err) => {
                    // console.log(err)
                }).finally(() => {
                    this.loading = false;

                });
            },
            showCourseDetail(course) {
                this.courseDetailDialog = true;
                this.course = course;
            },
            reset() {
                this.search = {
                    academic_year: "",
                    program_id: "",
                    grade_id: "",
                    type: "",
                }
                this.getAssignedTeacherCourses();
            },
        },
    }
</script>

<style scoped>

</style>
